import styled from "styled-components";
import {getColorFromTheme} from "../../../utils/style.utils";
import rhombuFrameLogo from "../../../assets/images/output-onlinepngtools.png"

export const LargeDashboardWrapper = styled.div`
    width: 100%;
    border-radius: var(--radius-lg);
    color: ${getColorFromTheme("white")};
    min-height: 193px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url(${rhombuFrameLogo}) repeat-x 0 0;
    background-size: 187px 187px;
    background-color: ${getColorFromTheme("secondaryColor")};
    user-select: none;

    * {
        color: inherit;
    }

    .title {
        font-size: calc(var(--step--1));
        font-weight: 600;
        line-height: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        flex-shrink: 0;
        justify-content: space-between;
        align-items: center;
        row-gap: var(--space-3);

        .icon-btn {
            cursor: pointer;

            svg {
                margin-inline-start: 10px;
                color: #ffff;
                width: 1em;
                font-size: inherit;
            }
        }
    }

    .balance {
        h1 {
            font-weight: 700;
            font-family: SpaceGrotesk, sans-serif;
            font-size: calc(var(--step-3));
            line-height: 0%;
            min-width: 200px;
            flex: 1 1 auto;
            > span{
                font-size: inherit;
                line-height: inherit;
            }
        }

    }

    ${({theme}: { theme: any }) => theme.breakpoints.down('lg')} {
        min-height: 150px;

        .balance h1 {
            font-size: calc(var(--step-2));
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down('md')} {
        min-height: 110px;

        .balance h1 {
            font-weight: 600;
            font-family: SpaceGrotesk;
            font-size: calc(var(--step-2));
        }
    }
`
export const Wrapper = styled.div`
    ${({theme}: { theme: any }) => theme.breakpoints.down('md')} {
        .title {
            font-size: var(--text-xs);
            font-family: Inter, sans-serif;
            font-weight: 400;

            .icon-btn {
                cursor: pointer;

                svg {
                    margin-inline-start: 10px;
                    color: #ffff;
                    width: 1em;
                    font-size: inherit;
                }
            }
        }

        .dashboard-action {
            button {
                padding: var(--space-3) calc(var(--space-4) + 1px); // 12px 15px
                font-size: var(--step--1);
            }

            button:first-child {
                background-color: transparent;
                border: 1px solid #D0D5DD;
                color: black;

                svg, svg * {
                    stroke: black;
                }
            }

            button:last-child {
                background-color: #000000;
            }
        }
    }

    .dashboard-action {
        [data-theme="dark"] & button {
            background-color: #FFFFFF;
            color: black;

            svg, svg * {
                stroke: black;
            }
        }
    }
`